import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.6931 5.87342C12.7829 5.87342 13.6664 4.98993 13.6664 3.90009C13.6664 2.81025 12.7829 1.92676 11.6931 1.92676C10.6032 1.92676 9.71973 2.81025 9.71973 3.90009C9.71973 4.98993 10.6032 5.87342 11.6931 5.87342Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.30634 5.87342C5.39618 5.87342 6.27967 4.98993 6.27967 3.90009C6.27967 2.81025 5.39618 1.92676 4.30634 1.92676C3.2165 1.92676 2.33301 2.81025 2.33301 3.90009C2.33301 4.98993 3.2165 5.87342 4.30634 5.87342Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.6931 14.0734C12.7829 14.0734 13.6664 13.1899 13.6664 12.1C13.6664 11.0102 12.7829 10.1267 11.6931 10.1267C10.6032 10.1267 9.71973 11.0102 9.71973 12.1C9.71973 13.1899 10.6032 14.0734 11.6931 14.0734Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.30634 14.0734C5.39618 14.0734 6.27967 13.1899 6.27967 12.1C6.27967 11.0102 5.39618 10.1267 4.30634 10.1267C3.2165 10.1267 2.33301 11.0102 2.33301 12.1C2.33301 13.1899 3.2165 14.0734 4.30634 14.0734Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReorderIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
}

})